import { useNavigate } from "react-router"

import { Grid, Typography } from "@mui/material"
import { ArrowBackIos, ArrowRight } from "@mui/icons-material"

import { Box } from '@arredo/reactjs-ui';

import LinkButton from "../../../buttons/link"

const Title = ({ voucherReference, voucherReferencePath, vouchersPath, voucherLabel, title }) => {
    const history = useNavigate()
    return (
        <Box
            icon={
                <ArrowBackIos />
            }
            onIconClick={() => history(vouchersPath)}
            header={
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item>
                        <Typography variant='h5' component='h4'>
                            {title}
                        </Typography>
                    </Grid>

                </Grid>
            }
            actions={
                <Grid item>
                    <LinkButton
                        path={voucherReferencePath}
                        title={`${voucherLabel} ${voucherReference}`}
                        text={voucherLabel}
                        Icon={ArrowRight}
                    />
                </Grid>
            }
        />

    );
}
export default Title